<app-masked-text-box [control]="control" [mask]="mask" [maskFormat]="format"></app-masked-text-box>
